export const selectJobs = state => state.cache.jobs;
export const selectSuppliers = state => state.cache.suppliers;
export const selectPayments = state => state.cache.payments;
export const selectMonths = state => state.cache.months;
